import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[wlDragAndDrop]',
  standalone: true,
})
export class DragAndDropDirective {
  @HostBinding(`attr.data-dragging-over`)
  isDraggingOver?: boolean = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() accept?: string[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() effect?: DataTransfer['dropEffect'];

  @Output()
  public fileDropped = new EventEmitter<File[]>();

  @HostListener('document:dragenter', ['$event'])
  public onDragEnter(event: DragEvent) {
    if (this.isTargetHost(event)) {
      event.stopPropagation();
      event.preventDefault();
      this.addDraggingAttributes();
    } else {
      this.removeDraggingAttributes();
    }
  }

  @HostListener('document:dragleave', ['$event'])
  public onDragLeave(event: DragEvent) {
    if (this.isTargetHost(event)) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  @HostListener('document:drop', ['$event'])
  public onDrop(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();

    if (this.isTargetHost(event)) {
      const acceptedFiles = this.getAcceptedFiles(event);

      if (acceptedFiles.length > 0) {
        this.fileDropped.emit(acceptedFiles);
      }

      this.removeDraggingAttributes();
    }
  }

  @HostListener('document:dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();

    const isTargetHost = this.isTargetHost(event);

    if (event.dataTransfer) {
      if (isTargetHost && this.effect) {
        event.dataTransfer.dropEffect = this.effect;
      }

      if (!isTargetHost) {
        event.dataTransfer.dropEffect = 'none';
      }
    }
  }

  constructor(private readonly hostElement: ElementRef) {}

  private isTargetHost(event: DragEvent) {
    return (
      event.target === this.hostElement.nativeElement ||
      this.hostElement.nativeElement.contains(event.target)
    );
  }

  private getAcceptedFiles(event: DragEvent) {
    const fileList = event.dataTransfer?.files;

    if (!fileList) {
      return [];
    }

    return Array.from(fileList).filter((file) =>
      this.accept ? this.accept.includes(file.type) : true
    );
  }

  addDraggingAttributes() {
    if (!this.isDraggingOver) {
      this.isDraggingOver = true;
    }
  }

  removeDraggingAttributes() {
    if (this.isDraggingOver) {
      this.isDraggingOver = false;
    }
  }
}
